// src/services/routeService.js

// Ajusta la URL base según donde esté tu RouteController
// Si es el microservicio de rutas suele ser /api/v2/route
const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v2/routes`; 

export const getAllCities = async (token) => {
  try {
    const response = await fetch(`${API_URL}/cities/all`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: No se pudieron obtener las ciudades`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en getAllCities:", error);
    return [];
  }
};

/**
 * Obtiene la información de la ciudad (citId, citName) a partir del ID de una ruta.
 * Endpoint correspondiente en backend: GET /api/v2/routes/{rouId}/city
 */
export const getCityByRouteId = async (rouId, token) => {
  try {
    const response = await fetch(`${API_URL}/${rouId}/city`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: No se pudo obtener la ciudad para la ruta ${rouId}`);
    }

    // Retorna el objeto JSON que envía el backend, ej: { citId: 1, citName: "Caracas" }
    return await response.json();
  } catch (error) {
    console.error(`Error en getCityByRouteId para la ruta ${rouId}:`, error);
    return null;
  }
};

export const getRouteById = async (token, rouId) => {
  try {
    const response = await fetch(`${API_URL}/route/${rouId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return await response.json();

  } catch (error) {
    console.error(`Error al obtener detalle de la ruta ${rouId}:`, error);
    throw error;
  }
};